module.exports = __webpack_public_path__ + "img/company-6.7f7113dc.png";